module.exports = __webpack_public_path__ + "img/__smart-city-inicial-min.6d5d6145.png";